import React, { useMemo } from "react";
import Collapsable from "../custom/Collapsable";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ExamFormatCard from "../cards/ExamFormatCard";
import renderHTML from "lib/render-html";

const ExamFormat: React.FC<ExamFormatProps> = ({ content }) => {
  const data = useMemo(() => {
    return {
      heading: content.topic_name,
      subHeading: content.sub_heading,
      paragraph: content.description,
      icon: content.service_detail_image_path,
      contents: content.contents,
    };
  }, [content]);
  if (!data.subHeading && !data.contents && !data.heading) return null;
  return (
    <Collapsable heading={data.heading} isOpen={true}>
      <Box>
        {data.subHeading ? (
          <Typography paragraph>{renderHTML(data.subHeading)}</Typography>
        ) : null}
        <Grid container spacing={3}>
          {data.contents && data.contents.length > 0
            ? data.contents.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  key={`examformat-course-` + index}
                >
                  <ExamFormatCard
                    title={item.heading}
                    subTitle={item.list[0]}
                    icon={
                      item.service_detail_image_path
                        ? process.env.NEXT_PUBLIC_ADMIN_URL +
                          "storage/images/" +
                          item.service_detail_image_path
                        : "/images/icons/exam-format/Exam-Duration.svg"
                    }
                  />
                </Grid>
              ))
            : null}
        </Grid>
      </Box>
    </Collapsable>
  );
};

export default ExamFormat;
